import React from "react";
import "./TopContactBar.css";

function TopContactBar() {

  return (

    <div className="top-contact-bar">

      <div className="top-contact-track">

        <div className="top-contact-content">

          <span>
            📞 Call: 0799 090 598
          </span>

          <span>
            💬 WhatsApp: 0775 137 928
          </span>

          <span>
            ✉ info@satimatechnova.co.ke
          </span>

        </div>


        <div className="top-contact-content">

          <span>
            📞 Call: 0799 090 598
          </span>

          <span>
            💬 WhatsApp: 0775 137 928
          </span>

          <span>
            ✉ info@satimatechnova.co.ke
          </span>

        </div>

      </div>

    </div>

  );
}

export default TopContactBar;